import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  features: {
    icon: string,
    title: string,
    about: string
  }[] = [
    {
      icon: "assets/illustrations/assign.svg",
      title: "Verified profiles",
      about: "Every professional and trustee is verified with Aadhaar"
    },
    {
      icon: "assets/illustrations/connected.svg",
      title: "Stay connected",
      about: "Chat enables users to connect with professionals and Trustees"
    },
    {
      icon: "assets/illustrations/search.svg",
      title: "Powerful search",
      about: "Search for professionals or products in your locality"
    },
    {
      icon: "assets/illustrations/vault.svg",
      title: "Security",
      about: "Your account is only accessible with OTP"
    },
    {
      icon: "assets/illustrations/messaging.svg",
      title: "Manage tasks",
      about: "All proposals and tasks are in your hands"
    },
    {
      icon: "assets/illustrations/mail.svg",
      title: "Quick task completion",
      about: "Nearest professionals save your time"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
